export default __webpack_public_path__ + "static/media/diamond.1e45df05.png";